import React, { Component } from 'react'
import { riskItemRow, riskItemLabel } from '../style/inlines'
import { ListItem } from 'material-ui/List'
import RatingBar from './RatingBar'

export default class RiskItem extends Component {
  constructor(...props) {
    super(...props)

    this.state = {
      expanded: false
    }

    this.toggle = this.toggle.bind(this)
  }

  toggle(expanded = !this.state.expanded) {
    this.setState({ expanded })
  }

  render() {
    const { risk, owner, push } = this.props

    return (
      <ListItem onClick={() => push(`/risks/${risk.key}`)}>
        <div className='row'>
          <div {...riskItemRow}>
            <label {...riskItemLabel}>Title</label>
            <span>{risk.title}</span>
          </div>
          <div {...riskItemRow}>
            <label {...riskItemLabel}>Owner</label>
            <span>{owner.name}</span>
          </div>
          <div {...riskItemRow}>
            <label {...riskItemLabel}>Created</label>
            <span>{risk.created.toDateString()}</span>
          </div>
        </div>
        <RatingBar rating={risk.maxRating} />
      </ListItem>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/RiskItem.js